import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from "./components/ui/ScrollToTop";
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import VacationOverlay from './components/VacationOverlay';
import CookieBanner from './components/CookieBanner';
import HomePage from './pages/HomePage';
import PricesPage from './pages/PricesPage';
import PrivateServicesPage from './pages/PrivateServicesPage';
import BusinessServicesPage from './pages/BusinessServicesPage';
import ImprintPage from './pages/ImprintPage';
import PrivacyPage from './pages/PrivacyPage';
import AboutPage from './pages/AboutPage';

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved ? JSON.parse(saved) : false;
  });

  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'de';
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const toggleLanguage = () => {
    setLanguage(language === 'de' ? 'en' : 'de');
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
        <VacationOverlay language={language} />
        <Header 
          darkMode={darkMode} 
          toggleDarkMode={toggleDarkMode}
          language={language}
          toggleLanguage={toggleLanguage}
        />
        <main>
          <Routes>
            <Route path="/" element={<HomePage language={language} />} />
            <Route path="/prices" element={<PricesPage language={language} />} />
            <Route path="/private-services" element={<PrivateServicesPage language={language} />} />
            <Route path="/business-services" element={<BusinessServicesPage language={language} />} />
            <Route path="/about" element={<AboutPage language={language} />} />
            <Route path="/privacy" element={<PrivacyPage language={language} />} />
            <Route path="/imprint" element={<ImprintPage language={language} />} />
          </Routes>
        </main>
        <Footer language={language} />
        <CookieBanner language={language} />
      </div>
    </BrowserRouter>
  );
}

export default App;
